import React from 'react';
import './App.css';
import TibetanLesson from './components/TibetanLesson';

function App() {
  return (
    <div className="app">
      <TibetanLesson />
    </div>
  );
}

export default App;
